<template>
  <div>
    <div class="totalPie">
      <div class="tit">
        <p>溃坝风险分布</p>
        <el-button size="mini" round @click="mapfy" style="float: right;padding: 7px !important;padding-top: 0 !important;">地图复原</el-button>
        <!-- <h5 style="float: right;color: #fff;font-size: 16px;font-weight: bold;cursor: pointer;" @click="mapfy">地图复原</h5> -->
      </div>
      <!-- <div class="contents boderBottom">
        <p></p>
        <p class="title1">按流域统计
        <el-button size="mini" round @click="bigdialogClick('yjliuyu')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="liuyuAll!=0">总和：{{liuyuAll}}</span>
          <div class="Piebar" id="yjliuyubar"></div>
        </div>
      </div> -->
      <div class="contents boderBottom">
        <p></p>
        <p class="title1">按病险坝统计
        <el-button size="mini" round @click="bigdialogClick('yjbxb')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="bxAll!=0">病险坝总和：{{bxAll}}</span>
          <span v-if="bxyrAll!=0" style="margin-left: 40px;">病险有人坝总和：{{bxyrAll}}</span><br />
          <div class="Piebar" id="yjbxbbar"></div>
        </div>
      </div>
      <div class="contents">
        <p></p>
        <p class="title1">按老旧坝统计
        <el-button size="mini" round @click="bigdialogClick('yjljb')">大图</el-button>
        </p>
        <div class="Piebar">
          <span v-if="ljAll!=0">老旧坝总和：{{ljAll}}</span>
          <span v-if="ljyrAll!=0" style="margin-left: 40px;">老旧有人坝总和：{{ljyrAll}}</span><br />
          <div class="Piebar" id="yjljbbar"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    //5.21
    selectYDBSSLYSum,
    selectYDBSSLYSumB,
    selectYDBBXBCount,
    selectYDBBXBCountB,
    selectYDBLJBSum,
    selectYDBLJBSumB
  } from "@/api/api.js";
  import common from "../../common/js/common_val";
  export default {
    props: ['bzswitchClick'],
    data() {
      return {
        show: false,

        yjliuyubar: null,
        yjbxbbar: null,
        yjljbbar: null,

        liuyuAll: 0,
        bxAll: 0,
        bxyrAll: 0,
        ljAll: 0,
        ljyrAll: 0,

        lyCityName: [],
        lyCityId: [],
        LblueSum: [],
        LyellowSum: [],
        LorangeSum: [],
        LredSum: [],

        bxbCityName: [],
        bxbCityId: [],
        BblueSum: [],
        ByellowSum: [],
        BorangeSum: [],
        BredSum: [],
        BylueySum: [],
        ByyellowSum: [],
        ByorangeSum: [],
        ByredSum: [],

        ljbCityName: [],
        ljbCityId: [],
        LJblueSum: [],
        LJyellowSum: [],
        LJorangeSum: [],
        LJredSum: [],
        LJyblueSum: [],
        LJyyellowSum: [],
        LJyorangeSum: [],
        LJyredSum: [],

        ydbCodeLists: null,
        value: false,
      };
    },
    mounted() {
      let params = {
        regionCode: this.$store.state.nowxingzhengCode,
        yuShi: this.$store.state.yuShi
      };
      //获取淤地坝数量统计按流域
      this.ydbtotalForLiuyuNew(params);
      //获取淤地坝数量统计按病险坝
      this.ydbtotalForBxbNew(params);
      //获取淤地坝数量统计按老旧坝
      this.ydbtotalForLjbNew(params);
    },
    computed: {
      nowxingzhengCodes() {
        return this.$store.state.nowxingzhengCode; //需要监听的数据
      },
      myydbDataFuns() {
        return this.$store.state.myydbData; //需要监听的数据
      },
      yuShiFuns() {
        return this.$store.state.yuShi; //需要监听的数据
      },
    },
    watch: {
      bzswitchClick(newVal, oldVal) {
        this.liuyuAll = 0;
        this.bxAll = 0;
        this.bxyrAll = 0;
        this.ljAll = 0;
        this.ljyrAll = 0;

        this.value = newVal;
        let params = {
          regionCode: this.$store.state.nowxingzhengCode,
          ydbCodeList: this.$store.state.myydbData,
          yuShi: this.$store.state.yuShi
        };
        if(newVal == false){//饼图
          //获取淤地坝数量统计按流域
          this.ydbtotalForLiuyuNew(params);
          //获取淤地坝数量统计按病险坝
          this.ydbtotalForBxbNew(params);
          //获取淤地坝数量统计按老旧坝
          this.ydbtotalForLjbNew(params);
        }else {//柱图
          //获取淤地坝数量统计按流域
          this.ydbtotalForLiuyu(params);
          //获取淤地坝数量统计按病险坝
          this.ydbtotalForBxb(params);
          //获取淤地坝数量统计按老旧坝
          this.ydbtotalForLjb(params);
        }
      },

      nowxingzhengCodes(newVal, oldVal) {
        if (oldVal) {
          let params;
          if (this.$store.state.ydbryorssShow == false) {
            params = {
              regionCode: newVal,
              yuShi: this.$store.state.yuShi
            };
          } else {
            params = {
              regionCode: newVal,
              ydbCodeList: this.$store.state.myydbData,
              yuShi: this.$store.state.yuShi
            };
          }
          if(this.value == false){
            //获取淤地坝数量统计按流域
            this.ydbtotalForLiuyuNew(params);
            //获取淤地坝数量统计按病险坝
            this.ydbtotalForBxbNew(params);
            //获取淤地坝数量统计按老旧坝
            this.ydbtotalForLjbNew(params);
          }else {
            //获取淤地坝数量统计按流域
            this.ydbtotalForLiuyu(params);
            //获取淤地坝数量统计按病险坝
            this.ydbtotalForBxb(params);
            //获取淤地坝数量统计按老旧坝
            this.ydbtotalForLjb(params);
          }
        }
      },
      myydbDataFuns(newVal, oldVal) {
        if (oldVal != null) {
          let params;
          this.ydbCodeLists = newVal;
          if (this.$store.state.ydbryorssShow == false && this.$store.state.kxcxStatus == false && this.$store.state
            .dzmcxStatus == false && this.$store.state.dtjcxStatus == false) {
            params = {
              regionCode: this.$store.state.nowxingzhengCode,
              yuShi: this.$store.state.yuShi
            };
          } else {
            params = {
              regionCode: this.$store.state.nowxingzhengCode,
              ydbCodeList: newVal,
              yuShi: this.$store.state.yuShi
            };
          }

          if(this.value == false){
            //获取淤地坝数量统计按流域
            this.ydbtotalForLiuyuNew(params);
            //获取淤地坝数量统计按病险坝
            this.ydbtotalForBxbNew(params);
            //获取淤地坝数量统计按老旧坝
            this.ydbtotalForLjbNew(params);
          }else {
            //获取淤地坝数量统计按流域
            this.ydbtotalForLiuyu(params);
            //获取淤地坝数量统计按病险坝
            this.ydbtotalForBxb(params);
            //获取淤地坝数量统计按老旧坝
            this.ydbtotalForLjb(params);
          }
        }
      },
      yuShiFuns(newVal, oldVal) {
        let params = {
          regionCode: this.$store.state.nowxingzhengCode,
          ydbCodeList: this.$store.state.myydbData,
          yuShi: newVal
        };
        if(this.value == false){
          //获取淤地坝数量统计按流域
          this.ydbtotalForLiuyuNew(params);
          //获取淤地坝数量统计按病险坝
          this.ydbtotalForBxbNew(params);
          //获取淤地坝数量统计按老旧坝
          this.ydbtotalForLjbNew(params);
        }else {
          //获取淤地坝数量统计按流域
          this.ydbtotalForLiuyu(params);
          //获取淤地坝数量统计按病险坝
          this.ydbtotalForBxb(params);
          //获取淤地坝数量统计按老旧坝
          this.ydbtotalForLjb(params);
        }
      },
    },
    methods: {
      //地图复原事件
      mapfy() {
        if (common.jcglLayerGroup) {
          common.jcglLayerGroup.clearLayers();
        }
      },

      //大图点击事件
      bigdialogClick(type) {
        let echartsData = {};
        echartsData.type = type;
        echartsData.isBar = this.value;
        if (type == 'yjliuyu') {
          echartsData.title = '按流域统计';
        } else if (type == 'yjbxb') {
          echartsData.title = '按病险坝统计';
          echartsData.bxbCityName = this.bxbCityName;
          echartsData.bxbCityId = this.bxbCityId;
          echartsData.BblueSum = this.BblueSum;
          echartsData.ByellowSum = this.ByellowSum;
          echartsData.BorangeSum = this.BorangeSum;
          echartsData.BredSum = this.BredSum;
          echartsData.BylueySum = this.BylueySum;
          echartsData.ByyellowSum = this.ByyellowSum;
          echartsData.ByorangeSum = this.ByorangeSum;
          echartsData.ByredSum = this.ByredSum;
        } else if (type == 'yjljb') {
          echartsData.title = '按老旧坝统计';
          echartsData.ljbCityName = this.ljbCityName;
          echartsData.ljbCityId = this.ljbCityId;
          echartsData.LJblueSum = this.LJblueSum;
          echartsData.LJyellowSum = this.LJyellowSum;
          echartsData.LJorangeSum = this.LJorangeSum;
          echartsData.LJredSum = this.LJredSum;
          echartsData.LJyblueSum = this.LJyblueSum;
          echartsData.LJyyellowSum = this.LJyyellowSum;
          echartsData.LJyorangeSum = this.LJyorangeSum;
          echartsData.LJyredSum = this.LJyredSum;
        }
        this.$emit("bigDialogData", echartsData);
      },

      //获取淤地坝数量统计按流域柱图
      ydbtotalForLiuyu(params) {
        this.lyCityName = [];
        this.LblueSum = [];
        this.LyellowSum = [];
        this.LorangeSum = [];
        this.LredSum = [];
        selectYDBSSLYSum(params).then((res) => {
          // console.log(res)
          if (res.data.length != 0) {
            for (let i = 0; i < res.data.length; i++) {
              this.lyCityName.push(res.data[i].ydbSszl);
              this.LblueSum.push(res.data[i].blueSum);
              this.LyellowSum.push(res.data[i].yellowSum);
              this.LorangeSum.push(res.data[i].orangeSum);
              this.LredSum.push(res.data[i].redSum);
            }
          }
          this.liuyubar(this.lyCityName, this.LblueSum, this.LyellowSum, this.LorangeSum, this.LredSum);
        });
      },

      //获取淤地坝数量统计按流域饼图
      ydbtotalForLiuyuNew(params) {
        this.lyCityName = '全部地区';
        this.LblueSum = 0;
        this.LyellowSum = 0;
        this.LorangeSum = 0;
        this.LredSum = 0;
        selectYDBSSLYSumB(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.LblueSum = Number(res.data[i].blueSum);
            this.LyellowSum = Number(res.data[i].yellowSum);
            this.LorangeSum = Number(res.data[i].orangeSum);
            this.LredSum = Number(res.data[i].redSum);
          }
          this.liuyubarNew(this.lyCityName, this.LblueSum, this.LyellowSum, this.LorangeSum, this.LredSum);
        });
      },

      //病险坝统计柱图
      ydbtotalForBxb(params) {
        this.bxbCityName = [];
        this.bxbCityId = [];
        this.BblueSum = [];
        this.ByellowSum = [];
        this.BorangeSum = [];
        this.BredSum = [];
        selectYDBBXBCount(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.bxbCityName.push(res.data[i].addressName);
            this.bxbCityId.push({
              code: res.data[i].addressCode,
              name: res.data[i].addressName
            });
            this.BblueSum.push(res.data[i].blueSum);
            this.ByellowSum.push(res.data[i].yellowSum);
            this.BorangeSum.push(res.data[i].orangeSum);
            this.BredSum.push(res.data[i].redSum);
          }
          this.bxbbar(this.bxbCityId, this.bxbCityName, this.BblueSum, this.ByellowSum, this.BorangeSum, this
            .BredSum);
        });
      },

      //病险坝统计饼图
      ydbtotalForBxbNew(params) {
        this.bxbCityName = '全部地区';
        this.BblueSum = 0;
        this.ByellowSum = 0;
        this.BorangeSum = 0;
        this.BredSum = 0;
        this.BylueySum = 0;
        this.ByyellowSum = 0;
        this.ByorangeSum = 0;
        this.ByredSum = 0;
        selectYDBBXBCountB(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.BblueSum = Number(res.data[i].blueSum);
            this.ByellowSum = Number(res.data[i].yellowSum);
            this.BorangeSum = Number(res.data[i].orangeSum);
            this.BredSum = Number(res.data[i].redSum);
            this.BylueySum = Number(res.data[i].xyyrblueSum);
            this.ByyellowSum = Number(res.data[i].xyyryellowSum);
            this.ByorangeSum = Number(res.data[i].xyyrorangeSum);
            this.ByredSum = Number(res.data[i].xyyrredSum);
          }
          this.bxbbarNew(this.bxbCityName, this.BblueSum, this.ByellowSum, this.BorangeSum, this.BredSum,
          this.BylueySum, this.ByyellowSum, this.ByorangeSum, this.ByredSum);
        });
      },

      //获取淤地坝数量统计按老旧坝柱图
      ydbtotalForLjb(params) {
        this.ljbCityName = [];
        this.ljbCityId = [];
        this.LJblueSum = [];
        this.LJyellowSum = [];
        this.LJorangeSum = [];
        this.LJredSum = [];
        selectYDBLJBSum(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.ljbCityName.push(res.data[i].addressName);
            this.ljbCityId.push({
              code: res.data[i].addressCode,
              name: res.data[i].addressName
            });
            this.LJblueSum.push(Number(res.data[i].blueSum));
            this.LJyellowSum.push(Number(res.data[i].yellowSum));
            this.LJorangeSum.push(Number(res.data[i].orangeSum));
            this.LJredSum.push(Number(res.data[i].redSum));
          }
          this.ljbbar(this.ljbCityId, this.ljbCityName, this.LJblueSum, this.LJyellowSum, this.LJorangeSum, this.LJredSum);
        });
      },

      //获取淤地坝数量统计按老旧坝饼图
      ydbtotalForLjbNew(params) {
        this.ljbCityName = '全部地区';
        this.LJblueSum = 0;
        this.LJyellowSum = 0;
        this.LJorangeSum = 0;
        this.LJredSum = 0;
        this.LJyblueSum = 0;
        this.LJyyellowSum = 0;
        this.LJyorangeSum = 0;
        this.LJyredSum = 0;
        selectYDBLJBSumB(params).then((res) => {
          // console.log(res)
          for (let i = 0; i < res.data.length; i++) {
            this.LJblueSum = Number(res.data[i].blueSum);
            this.LJyellowSum = Number(res.data[i].yellowSum);
            this.LJorangeSum = Number(res.data[i].orangeSum);
            this.LJredSum = Number(res.data[i].redSum);
            this.LJyblueSum = Number(res.data[i].xyyrblueSum);
            this.LJyyellowSum = Number(res.data[i].xyyryellowSum);
            this.LJyorangeSum = Number(res.data[i].xyyrorangeSum);
            this.LJyredSum = Number(res.data[i].xyyrredSum);
          }
          this.ljbbarNew(this.ljbCityName, this.LJblueSum, this.LJyellowSum, this.LJorangeSum, this.LJredSum,
          this.LJyblueSum, this.LJyyellowSum, this.LJyorangeSum, this.LJyredSum);
        });
      },

      //淤地坝数量统计柱图
      liuyubar(lyCityName, LblueSum, LyellowSum, LorangeSum, LredSum) {
        let _this = this;
        this.yjliuyubar = this.$echarts.init(document.getElementById("yjliuyubar"));

        this.yjliuyubar.on('click', function(value) {
          let currentObject = [];
          // for (let i = 0; i < lyCityId.length; i++) {
          //   if (value.name == lyCityId[i].name) {
          //     currentObject.push({
          //       code: lyCityId[i].code,
          //       sectionName: value.seriesName
          //     });
          //   }
          // }
          _this.$emit("ClickNames", currentObject);
          _this.$emit("DialogVisibles", true);
          _this.$emit("cxDialogVisibles", false);
        });

        let option = {
          title: {
            show: false,
            text: "",
            textStyle: {
              fontSize: 25,
              fontWeight: "normal",
              color: "#fff",
            },
            x: "center",
          },

          tooltip: {
            trigger: "axis",
            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效
              type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
            },
          },
          grid: {
            left: "2%",
            right: "2%",
            bottom: "10%",
            top: "20%",
            containLabel: true,
          },
          legend: {
            data: ["四级", "三级", "二级", "一级"],
            /*right: 10,*/
            top: "4%",
            textStyle: {
              color: "#fff",
              fontSize: 14
            },
            itemWidth: 12,
            itemHeight: 10,
            // itemGap: 35
            selected: {
              '四级': false
            },
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 5, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }, ],
          xAxis: {
            type: "category",
            data: lyCityName,
            axisLine: {
              lineStyle: {
                color: "#ccc",
              },
            },
            axisLabel: {
              // interval: 0,
              // rotate: 40,
              textStyle: {
                fontFamily: "Microsoft YaHei",
                fontSize: 14
              },
            },
          },

          yAxis: {
            name: "数量",
            type: "value",
            // max: "150",
            axisLine: {
              show: false,
              lineStyle: {
                color: "#ccc",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,0.3)",
              },
            },
            axisLabel: {},
          },

          series: [{
              name: "四级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                },
              },
              data: LblueSum,
            },
            {
              name: "三级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                },
              },
              data: LyellowSum,
            },
            {
              name: "二级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ffa500",
                    },
                    {
                      offset: 1,
                      color: "#ffa500",
                    },
                  ]),
                },
              },
              data: LorangeSum,
            },
            {
              name: "一级",
              type: "bar",
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff2d51",
                    },
                    {
                      offset: 1,
                      color: "#ff2d51",
                    },
                  ]),
                },
              },
              data: LredSum,
            },
          ],
        };
        this.yjliuyubar.clear();
        this.yjliuyubar.setOption(option);
      },

      //淤地坝数量统计饼图
      liuyubarNew(lyCityName, LblueSum, LyellowSum, LorangeSum, LredSum) {
        let _this = this;
        this.yjliuyubar = this.$echarts.init(document.getElementById("yjliuyubar"));
        this.liuyuAll = Number(LblueSum) + Number(LyellowSum) + Number(LorangeSum) + Number(LredSum);

        // 点击图标
        this.yjliuyubar.on('click', function(value) {
          // 全部省份的不能点击
            let currentObj = [{
              code: '',
              sectionName: value.data.name
            }]
            _this.$emit("ClickNames", currentObj);
            _this.$emit("DialogVisibles", true);
            _this.$emit("cxDialogVisibles", false);
        });
        let  option = {
          legend: {
            left:'right',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name: "二级"},{name: "一级"}],
            textStyle:{
              color:'#fff'
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: lyCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '70%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: LblueSum, name: "四级",itemStyle:{color:'#00B3FE'}},
                { value: LyellowSum, name: "三级",itemStyle:{color:'#FFE557'}},
                { value: LorangeSum, name: "二级",itemStyle:{color:'#ffa500'}},
                { value: LredSum, name: "一级",itemStyle:{color:'#ff2d51'}},
              ]
            },
          ]
        };
        this.yjliuyubar.clear();
        this.yjliuyubar.setOption(option);
      },

      //病险坝统计柱图
      bxbbar(bxbCityId, bxbCityName, BblueSum, ByellowSum, BorangeSum, BredSum) {
        let _this = this;
        this.yjbxbbar = this.$echarts.init(document.getElementById("yjbxbbar"));

        this.yjbxbbar.on('click', function(value) {
          if (value.componentSubType == 'bar') {
            let currentObject = [];
            let JYDJ;
            if (value.seriesName == '一级') {
              JYDJ = 'RED';
            } else if (value.seriesName == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.seriesName == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            for (let i = 0; i < bxbCityId.length; i++) {
              if (value.name == bxbCityId[i].name) {
                currentObject.push({
                  regionCode: bxbCityId[i].code,
                  JYDJ: JYDJ,
                  yuShi: _this.$store.state.yuShi,
                  bxlj: 'bx',
                });
              }
            }
            _this.$emit("ClickNames", currentObject);
          }
        });

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '10%',
            top: '20%',
            containLabel: true
          },
          legend: {
            data: ['四级', '三级', '二级', '一级'],
            // right: 'center',
            top: 0,
            textStyle: {
              color: "#fff"
            },
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 10,
            selected: {
              '四级': false
            },
          },
          xAxis: {
            type: 'category',
            data: bxbCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            },
          },
          yAxis: {
            name: "数量",
            type: 'value',
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 20, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }],
          series: [{
              name: '四级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE ",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                  // barBorderRadius: 5,
                },
              },
              data: BblueSum
            },
            {
              name: '三级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  // barBorderRadius: 5,
                }
              },
              data: ByellowSum
            },
            {
              name: '二级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ffa500 ",
                    },
                    {
                      offset: 1,
                      color: "#ffa500",
                    },
                  ]),
                  // barBorderRadius: 5,
                }
              },
              data: BorangeSum
            },
            {
              name: '一级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff2d51",
                    },
                    {
                      offset: 1,
                      color: "#ff2d51",
                    },
                  ]),
                  // barBorderRadius: 5,
                }
              },
              data: BredSum
            },
          ]
        };
        this.yjbxbbar.clear();
        this.yjbxbbar.setOption(option);
      },

      //病险坝统计饼图
      bxbbarNew(bxbCityName, BblueSum, ByellowSum, BorangeSum, BredSum, BylueySum, ByyellowSum, ByorangeSum, ByredSum) {
        let _this = this;
        this.yjbxbbar = this.$echarts.init(document.getElementById("yjbxbbar"));
        this.bxAll = Number(ByellowSum) + Number(BorangeSum) + Number(BredSum);
        this.bxyrAll = Number(ByyellowSum) + Number(ByorangeSum) + Number(ByredSum);

        // 建成年代也要切换
        this.yjbxbbar.on('click', function(value) {
          if (value.componentSubType == 'pie') {
            let sfyr, JYDJ;
            if (value.data.type == "病险有人坝") {
              sfyr = 1;
            } else{
              sfyr = 0;
            }
            if (value.name == '一级') {
              JYDJ = 'RED';
            } else if (value.name == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.name == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            let currentObject = [];
              currentObject.push({
                regionCode: _this.$store.state.nowxingzhengCode,
                yuShi: _this.$store.state.yuShi,
                bxlj: 'bx',
                sfyr: sfyr,
                JYDJ: JYDJ
              });
            _this.$emit("ClickNames", currentObject);
          }
        });

        let  option = {
          title : [{
              text: '病险坝',
              left: '17%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }, {
              text: '病险有人坝',
              left: '65%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }],
          legend: {
            left:'center',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name:"二级"},{name: "一级"}],
            textStyle:{
              color:'#fff'
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: bxbCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['25%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: BblueSum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'病险坝'},
                { value: ByellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'病险坝'},
                { value: BorangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'病险坝'},
                { value: BredSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'病险坝'},
              ]
            },
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['75%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: BylueySum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'病险有人坝'},
                { value: ByyellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'病险有人坝'},
                { value: ByorangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'病险有人坝'},
                { value: ByredSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'病险有人坝'},
              ]
            },
          ]
        };
        this.yjbxbbar.clear();
        this.yjbxbbar.setOption(option);
      },

      //老旧坝统计柱图
      ljbbar(ljbCityId, ljbCityName, LJblueSum, LJyellowSum, LJorangeSum, LJredSum) {
        let _this = this;
        this.yjljbbar = this.$echarts.init(document.getElementById("yjljbbar"));
        this.yjljbbar.on('click', function(value) {
          if (value.componentSubType == 'bar') {
            let currentObject = [];
            let JYDJ;
            if (value.seriesName == '一级') {
              JYDJ = 'RED';
            } else if (value.seriesName == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.seriesName == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            for (let i = 0; i < ljbCityId.length; i++) {
              if (value.name == ljbCityId[i].name) {
                currentObject.push({
                  regionCode: ljbCityId[i].code,
                  JYDJ: JYDJ,
                  yuShi: _this.$store.state.yuShi,
                  bxlj: 'lj',
                });
              }
            }
            _this.$emit("ClickNames", currentObject);
          }
        });

        let option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { // 坐标轴指示器，坐标轴触发有效
              type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '2%',
            right: '4%',
            bottom: '10%',
            top: '20%',
            containLabel: true
          },
          legend: {
            data: ['四级', '三级', '二级', '一级'],
            // right: 'center',
            top: 0,
            textStyle: {
              color: "#fff"
            },
            itemWidth: 10,
            itemHeight: 10,
            itemGap: 10,
            selected: {
              '四级': false
            },
          },
          xAxis: {
            type: 'category',
            data: ljbCityName,
            axisLine: {
              lineStyle: {
                color: 'white'
              }
            },
            axisLabel: {
              textStyle: {
                fontFamily: 'Microsoft YaHei'
              }
            },
          },
          yAxis: {
            name: "数量",
            type: 'value',
            // max: '1200',
            axisLine: {
              show: false,
              lineStyle: {
                color: '#ccc'
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(255,255,255,0.3)'
              }
            },
            axisLabel: {}
          },
          dataZoom: [{
            type: "slider", //slider表示有滑动块的，
            show: true,
            zoomLock: false,
            left: 'center',
            bottom: '3%',
            height: '15',
            xAxisIndex: [0], //表示x轴折叠
            start: 1, //数据窗口范围的起始百分比,表示1%
            end: 30, //数据窗口范围的结束百分比,表示35%坐标
            textStyle: {
              color: "#ccc",
              // fontWeight: "bold",
              fontSize: 12,
            },
          }],
          series: [{
              name: '四级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#00B3FE ",
                    },
                    {
                      offset: 1,
                      color: "#00B3FE",
                    },
                  ]),
                  // barBorderRadius: 12,
                },
              },
              data: LJblueSum
            },
            {
              name: '三级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#FFE557",
                    },
                    {
                      offset: 1,
                      color: "#FFE557",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: LJyellowSum
            },
            {
              name: '二级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ffa500 ",
                    },
                    {
                      offset: 1,
                      color: "#ffa500",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: LJorangeSum
            },
            {
              name: '一级',
              type: 'bar',
              barWidth: "8px",
              itemStyle: {
                normal: {
                  color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                      offset: 0,
                      color: "#ff2d51 ",
                    },
                    {
                      offset: 1,
                      color: "#ff2d51",
                    },
                  ]),
                  // barBorderRadius: 11,
                }
              },
              data: LJredSum
            },
          ]
        };
        this.yjljbbar.clear();
        this.yjljbbar.setOption(option);
      },

      //老旧坝统计饼图
      ljbbarNew(ljbCityName, LJblueSum, LJyellowSum, LJorangeSum, LJredSum, LJyblueSum, LJyyellowSum, LJyorangeSum, LJyredSum) {
        let _this = this;
        this.yjljbbar = this.$echarts.init(document.getElementById("yjljbbar"));
        this.ljAll = Number(LJyellowSum) + Number(LJorangeSum) + Number(LJredSum);
        this.ljyrAll = Number(LJyyellowSum) + Number(LJyorangeSum) + Number(LJyredSum);
        // 还有一个总计的
        this.yjljbbar.on('click', function(value) {
          if (value.componentSubType == 'pie') {
            let sfyr, JYDJ;
            if (value.data.type == "老旧有人坝") {
              sfyr = 1;
            } else{
              sfyr = 0;
            }
            if (value.name == '一级') {
              JYDJ = 'RED';
            } else if (value.name == '二级') {
              JYDJ = 'ORANGE';
            } else if (value.name == '三级') {
              JYDJ = 'YELLOW';
            } else{
              JYDJ = 'BLUE';
            }
            let currentObject = [];
              currentObject.push({
                regionCode: _this.$store.state.nowxingzhengCode,
                yuShi: _this.$store.state.yuShi,
                bxlj: 'lj',
                sfyr: sfyr,
                JYDJ: JYDJ
              });
            _this.$emit("ClickNames", currentObject);
          }
        });

        let option = {
          title : [{
              text: '老旧坝',
              left: '17%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }, {
              text: '老旧有人坝',
              left: '65%',
              bottom: '2%',
              x:'center',
              textStyle: {
                  fontWeight: 'normal',
                  fontSize: 14,
                  color: '#fff'
              },
          }],
          legend: {
            left:'center',
            top:5,
            data:[{name:"四级"},{name: "三级"},{name:"二级"},{name:"一级"}],
            textStyle:{
              color:'#fff'
            },
            selected: {
              '四级': false
            },
          },
          tooltip: {
            trigger: 'item',
            formatter: ljbCityName+' <br/>{b}: {c} '
          },
          series: [
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['25%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: LJblueSum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'老旧坝'},
                { value: LJyellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'老旧坝'},
                { value: LJorangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'老旧坝'},
                { value: LJredSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'老旧坝'},
              ]
            },
            {
              type: 'pie',
              radius: [0, '70%'],
              center: ['75%', '50%'],
              label: {
                position: 'inner',
                fontSize: 14,
                formatter:'{c}'
              },
              startAngle:270,
              labelLine: {
                show: false
              },
              data: [
                { value: LJyblueSum, name: "四级",itemStyle:{color:'#00B3FE'}, type:'老旧有人坝'},
                { value: LJyyellowSum, name: "三级",itemStyle:{color:'#FFE557'}, type:'老旧有人坝'},
                { value: LJyorangeSum, name: "二级",itemStyle:{color:'#ffa500'}, type:'老旧有人坝'},
                { value: LJyredSum, name: "一级",itemStyle:{color:'#ff2d51'}, type:'老旧有人坝'},
              ]
            },
          ]
        };
        this.yjljbbar.clear();
        this.yjljbbar.setOption(option);
      },

      Cancel() {
        this.DialogVisible = false;
      },
    },
  };
</script>

<style scoped>
  .totalPie {
    width: 100%;
    height: 850px;
    background: url(../../common/images/dbg.png) no-repeat center;
    background-size: 100% 100%;
  }

  .contents {
    width: 96%;
    height: 31%;
    margin-left: 2%;
    margin-top: 1%;
  }

  .contents p:nth-child(1) {
    float: left;
    width: 6px;
    height: 6px;
    margin: 12px 5px 12px 10px;
    background-color: #00B3FE;
  }

  .boderBottom {
    border-bottom: 1px dotted #ccc;
  }

  .title1 {
    height: 30px;
    line-height: 30px;
    font-size: 16px;
    font-weight: bold;
    color: #00B3FE;
  }

  .Piebar {
    width: 100%;
    height: 220px;
  }

  .Piebar>span{
    float: left;
    margin-top: 5px;
    margin-left: 10px;
    color: #fff;
    font-size: 14px;
  }

  >>>.el-button--mini, .el-button--mini.is-round {
    padding: 3px 10px;
    background: transparent;
    color: #fff;
    border: 1px solid #409EFF;
  }
</style>
